/**
 * Styles for ChallengeInfo component and its sub-components
 * Uses Material-UI's makeStyles for consistent theming
 */

import makeStyles from '@material-ui/core/styles/makeStyles'
import { isRtl } from '../../i18nInit'

/**
 * Main styles for ChallengeInfo component
 */
export const useChallengeInfoStyles = makeStyles((theme) => ({
  wrapper: {
    paddingBottom: '16px',
  },
  grid: {
    marginBottom: '16px',
    alignItems: 'center',
  },
  logo: {
    display: 'inline-block',
    height: '40px',
    width: 'auto',
    maxWidth: '100%',
    boxSizing: 'content-box',
  },
  listItem: {
    flexWrap: 'nowrap',
    alignItems: 'start',
    padding: '10px',
    marginBottom: '8px',
  },
  listItemDense: {
    padding: 0,
    marginBottom: '10px',
    background: 'transparent',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  listItemText: {
    marginTop: 0,
    marginBottom: 0,
    textAlign: isRtl ? 'right' : 'left',
  },
  listItemTextPrimary: {
    fontWeight: 700,
    fontSize: '0.6875rem',
    //lineHeight: '13px',
    lineHeight: '0.8125rem',
    opacity: 0.7,
    marginBottom: '2px',
  },
  listItemTextSecondary: {
    fontWeight: 500,
    fontSize: '0.8125rem',
    //lineHeight: '16px',
    lineHeight: '1rem',
    color: 'inherit',
  },
  // Icon wrapper. Sized in em on a 1rem font-size context, so the icon scales
  // with --os-scale alongside the surrounding text. Overrides the SVG's
  // intrinsic width/height so it fills the wrapper.
  listItemIcon: {
    minWidth: 'auto',
    width: '2rem',
    height: '2rem',
    fontSize: '1rem',
    //marginRight: isRtl ? 0 : '12px',
    //marginLeft: isRtl ? '12px' : 0,
    '& > svg': {
      width: '100%',
      height: '100%',
    },
  },
}))

/**
 * Styles for organizer logo display
 * @param isSvg - Whether the logo is an SVG file (affects sizing/padding)
 */
export const getLogoStyles = (isSvg: boolean) => ({
  height: isSvg ? '40px' : '30px',
  padding: isSvg ? '0' : '10px',
  background: isSvg ? 'transparent' : 'white',
  borderRadius: isSvg ? '0' : '8px',
})
